module.exports = __webpack_public_path__ + "media/images/responsive/articles/icon_favorite_inactive-1e006774d90c46c4ed30d2b069875b87.svg";